const accessLogo = new URL('../../../assets/kar/vit-karlskrona-kommun.png', import.meta.url).href;

// Load Google Fonts (only in browser)
if (typeof document !== 'undefined') {
  const karlskronaLightFont = document.createElement('link');
  karlskronaLightFont.rel = 'stylesheet';
  karlskronaLightFont.href =
    'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;1,300&family=Rubik:ital,wght@0,300;0,500;0,600;1,300;1,500;1,600&display=swap';
  document.head.appendChild(karlskronaLightFont);
}

export const karlskronaLightNew = {
  name: 'karlskrona:light-new',
  extends: 'citizen:light',
  cssPath: 'custom/styles/kar/karlskrona-light-new.theme',
  vuetify: {
    defaults: {
      AppAccessPage: {
        logoSrc: accessLogo,
        logoAlt: 'Karlskrona kommun',
        backgroundSrc: new URL('../../../assets/kar/header-bg.jpg', import.meta.url).href,
      },
      VBtn: {
        variant: 'elevated',
      },
      HBulletin: {
        HActionLink: {
          HScopedBulletinActionBtn: {
            size: 'default',
            variant: 'text',
            color: 'primary',
            icon: false,
            appendIcon: 'mdi:mdi-chevron-right',
          },
        },
      },
      HWorkspace: {
        HBulletin: {
          VCard: {
            color: null,
          },
        },
      },
      HShortcut: {
        VBadge: {
          color: 'badge-primary',
          inline: true,
        },
      },
    },
    theme: {
      dark: false,
      colors: {
        // Karlskrona brand colors - Hav (blue) as primary
        primary: '#144681',
        'on-primary': '#FFFFFF',
        'primary-lighten-1': '#3A6BA3',
        'primary-lighten-2': '#6A94C4',
        'primary-lighten-3': '#A5C0E0',

        // Secondary colors
        secondary: '#AC480D',
        'on-secondary': '#FFFFFF',
        'secondary-lighten-1': '#C9BFAE',
        'secondary-lighten-2': '#DCD5C9',
        'secondary-lighten-3': '#EEEAE4',

        // Semantic colors
        error: '#99092D',
        'error-lighten-1': '#B8524A',
        'error-lighten-2': '#CE9193',
        'on-error-lighten-2': '#001A1B',
        'error-lighten-3': '#EEEAE4',

        success: '#2F746B',
        'success-lighten-1': '#4A9E90',
        'success-lighten-2': '#8ABFB7',
        'success-lighten-3': '#C6DFE0',

        warning: '#D16F00',
        'warning-lighten-1': '#835400',
        'warning-lighten-2': '#E8B29C',
        'warning-lighten-3': '#FFDDB5',

        // Surface and background - clean white cards
        surface: '#FFFFFF',
        'on-surface': '#001A1B',
        'surface-variant': '#F5F5F5',
        'on-surface-variant': '#001A1B',
        background: '#F0F2F1',
        'on-background': '#001A1B',

        // Card background - white/light for new design
        'neutral-100': '#FFFFFF',
        'on-neutral-100': '#001A1B',

        // Header and toolbar - Hav (blue)
        toolbar: '#144681',
        'on-toolbar': '#FFFFFF',
        'header-button': '#FFFFFF',
        'dialog-header-button': '#144681',

        // Breadcrumb
        'breadcrumb-hover': '#E8EAE9',
        'on-breadcrumb': '#001A1B',

        // Bulletin/sidebar styling
        'bulletin-board': '#F5F5F5',
        'on-bulletin-board': '#001A1B',
        bulletin: '#FFFFFF',
        'on-bulletin': '#001A1B',
        'start-page': '#F0F2F1',
        'on-start-page': '#001A1B',

        // Badge colors - using brand colors
        'badge-disabled': '#A5A5A5',
        'badge-primary': '#144681',
        'badge-secondary': '#B19C80',
        'badge-tertiary': '#AC480D',

        // Category icon colors - for icon backgrounds instead of card backgrounds
        'icon-foretag': '#CE9193',
        'icon-fastigheter': '#CDBFB1',
        'icon-fullmakter': '#A0D4AA',
        'icon-utbildning': '#BCE4FA',
        'icon-barn': '#A0D4AA',
        'icon-omsorg': '#EBDBA3',
        'icon-arenden': '#DE9367',
        'icon-anstallning': '#c4a8c3',

        // Legacy category colors (kept for compatibility)
        foretag: '#CE9193',
        'on-foretag': '#001A1B',
        fastigheter: '#CDBFB1',
        'on-fastigheter': '#001A1B',
        fullmakter: '#A0D4AA',
        'on-fullmakter': '#001A1B',
        utbildning: '#BCE4FA',
        'on-utbildning': '#001A1B',
        omsorg: '#EBDBA3',
        'on-omsorg': '#001A1B',
        ovriga: '#C3B8CA',
        'on-ovriga': '#001A1B',
        forening: '#EBC79E',
        'on-forening': '#001A1B',

        // Brand colors - Skog, Strand, Hav, Skymning, Bär
        hav: '#144681',
        skog: '#2F746A',
        strand: '#B19C80',
        skymning: '#AC480D',
        bar: '#81203B',
        'strand-lighten-1': '#CDBFB1',
        'strand-lighten-2': '#EBE6E0',

        // Text colors
        black: '#001A1B',
        'black-lighten-1': '#333333',
        gray: '#605d62',
        'gray-lighten-1': '#79767a',
        'gray-lighten-2': '#F4F3F2',
        white: '#FFFFFF',
        'white-darken-1': '#EBE6E0',

        // Hover states
        'search-list-hover': '#EBE6E0',

        // UI elements
        disabled: '#A5A5A5',
        loader: '#144681',
        'loader-background': '#E0E3E1',
        scrollbar: '#144681',

        // Text colors
        'text-color-primary': '#1A1C1E',
        'text-color-secondary': '#41474D',

        // Sector colors
        adshavare: '#91A49D',
        'on-adshavare': '#001A1B',
        anstallningar: '#c4a8c3',
        'on-anstallningar': '#001A1B',
        'sector-privat': '#adc8ac',
        'sector-företag': '#f8ddcd',
        'on-sector-privat': '#001A1B',
        'on-sector-företag': '#001A1B',

        // Process state
        'process-state-active': '#A99175',

        // Bulletin severity colors
        'bulletin-informational': '#FFFFFF',
        'on-bulletin-informational': '#001A1B',
        'bulletin-warning': '#ebdba3',
        'on-bulletin-warning': '#001A1B',
        'bulletin-critical': '#FFB3BA',
        'on-bulletin-critical': '#001A1B',
        'bulletin-success': '#B8E6D5',
        'on-bulletin-success': '#001A1B',

        // My services colors
        'my-eservices': '#DE9367',
        'on-my-eservices': '#001A1B',
        'my-cases': '#DE9367',
        'on-my-cases': '#001A1B',
        'my-cases-action': '#DE9367',
        'on-my-cases-action': '#FFFFFF',

        // Page header background colors (consistent English naming)
        'page-companies-header-bg': '#F0F2F1',
        'on-page-companies-header-bg': '#001A1B',
        'page-properties-header-bg': '#F0F2F1',
        'on-page-properties-header-bg': '#001A1B',
        'page-authorizations-header-bg': '#F0F2F1',
        'on-page-authorizations-header-bg': '#001A1B',
        'page-children-header-bg': '#F0F2F1',
        'on-page-children-header-bg': '#001A1B',
        'page-enrollments-header-bg': '#F0F2F1',
        'on-page-enrollments-header-bg': '#001A1B',
        'page-employments-header-bg': '#F0F2F1',
        'on-page-employments-header-bg': '#001A1B',
        'page-eservices-header-bg': '#F0F2F1',
        'on-page-eservices-header-bg': '#001A1B',
        'page-cases-header-bg': '#F0F2F1',
        'on-page-cases-header-bg': '#001A1B',

        // Item card border colors (card-*)
        'card-assignment': '#D1E550',
        'on-card-assignment': '#001A1B',
        'card-company': '#CE9193',
        'card-property': '#CDBFB1',
        'card-authorization': '#A0D4AA',
        'card-child': '#91A49D',
        'card-enrollment': '#BCE4FA',
        'card-employment': '#c4a8c3',
        'card-case': '#DE9367',
        'card-eservice': '#DE9367',
        'card-facility': '#CE9193',
        'card-berth': '#bcdefa',
        'card-servingpermit': '#CE9193',
        'card-servingplace': '#CE9193',
        'card-salespermit': '#CE9193',
        'card-salespoint': '#CE9193',
        'card-association': '#8C8C8C',

        // Category colors for service areas
        'arbete-naringsliv': '#CE9193',
        'on-arbete-naringsliv': '#001A1B',
        'boende-miljo': '#CDBFB1',
        'on-boende-miljo': '#001A1B',
        'kommun-politik': '#2563EB',
        'on-kommun-politik': '#FFFFFF',
        'omsorg-stod': '#EBDBA3',
        'on-omsorg-stod': '#001A1B',
        ovrigt: '#C3B8CA',
        'on-ovrigt': '#001A1B',
        'forskola-skola': '#BCE4FA',
        'on-forskola-skola': '#001A1B',
        'kultur-fritid-turism': '#B8A080',
        'on-kultur-fritid-turism': '#001A1B',
        raddningstjansten: '#F28B6D',
        'on-raddningstjansten': '#001A1B',

        // Chip styling
        'chip-active': '#144681',
        'on-chip-active': '#FFFFFF',

        // Background variants
        'background-3': '#EEF8FF',
        'on-background-3': '#001A1B',
        'background-4': '#91A7CA',
        'on-background-4': '#001A1B',
      },
    },
  },
};
